import {
  createInterviewDoneAttachment,
  getMyQuestionSuggest,
  updateMyQuestionSuggest,
} from "./interview-services";

export {
  createInterviewDoneAttachment,
  getMyQuestionSuggest,
  updateMyQuestionSuggest,
};
